export enum FactoryInvoiceTypeValue {
  SHIPMENT = 1,
  PERIODICAL = 2,
  BATCH_DEPOSIT = 3,
  BATCH_BALANCE = 4,
}

export const regularFactoryInvoiceTypes = [
  FactoryInvoiceTypeValue.SHIPMENT,
  FactoryInvoiceTypeValue.PERIODICAL,
];

export const batchFactoryInvoiceTypes = [
  FactoryInvoiceTypeValue.BATCH_DEPOSIT,
  FactoryInvoiceTypeValue.BATCH_BALANCE,
];

export function getFactoryInvoiceDetailRouteName(
  type: FactoryInvoiceTypeValue
): "FactoryInvoiceViewPage" | "BatchInvoiceViewPage" {
  return batchFactoryInvoiceTypes.includes(type)
    ? "BatchInvoiceViewPage"
    : "FactoryInvoiceViewPage";
}

export function getFactoryInvoiceTypeName(
  type: FactoryInvoiceTypeValue,
  usedDepositPercent?: number
): string {
  if (type === FactoryInvoiceTypeValue.PERIODICAL) {
    return "Periodical";
  }

  if (type === FactoryInvoiceTypeValue.BATCH_DEPOSIT) {
    return usedDepositPercent == null
      ? "Deposit"
      : `${usedDepositPercent}% Deposit`;
  }

  if (type === FactoryInvoiceTypeValue.BATCH_BALANCE) {
    return "Balance";
  }

  return "Shipment";
}
